export default __webpack_public_path__ + "static/media/silver_reflection_blur.162ad2ce.png";